import { render, staticRenderFns } from "./courseView.vue?vue&type=template&id=64ece31e&scoped=true"
import script from "./courseView.vue?vue&type=script&lang=js"
export * from "./courseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ece31e",
  null
  
)

export default component.exports